
// // import './App.css';
// // import { HashRouter, Routes, Route } from "react-router-dom";

// // import Navbar from "./components/Navbar";
// // import ScrollToTop from "./components/ScrollToTop";   // ← Import here
// // import MapLocation from "./components/MapLocation";

// // // Page Components
// // import Home from "./pages/Home.jsx";
// // import ReportSection from "./components/Reportsection";
// // import MainFooter from './components/MainFooter.jsx';
// // import AboutUs from './components/AboutUs.jsx';
// // import LeaderShip from './AboutUs/LeaderShip.jsx';
// // import TeamMember from './AboutUs/TeamMember.jsx';
// // import PastPresedent from './AboutUs/PastPresident.jsx';
// // import Membership from './components/MemberShip.jsx';
// // import PressRelease from './News/PressRelease.jsx';
// // import PressCoverage from './News/PressCoverage.jsx';
// // import MemberShipOverview from './components/MemberShipOverview.jsx';
// // import GlobalResearch from './GlobalResearch/GlobalResearch.jsx';
// // import ResearchRepositoryPage from './GlobalResearch/ResearchRepositoryPage.jsx';
// // import KnowledgeSection from './KnowledgeCenter/KnowledgeSection.jsx';
// // import HomeKnowledge from './KnowledgeCenter/HomeKnowledge.jsx';

// // import AboutKnowledge from './KnowledgeCenter/AboutKnowledge.jsx';
// // import AssochamReports from './KnowledgeCenter/AssochamReport.jsx';
// // import AssochamVoice from './KnowledgeCenter/AssochamVoice.jsx';
// // import AssochamBulletins from './KnowledgeCenter/AssochamBulletins.jsx';
// // import KnowledgeDetail from './KnowledgeCenter/AboutKnowledge.jsx';
// // import HeroBgSection from './HeroBgSection.jsx';
// // import ImageLibrary from './News/ImageLibrary.jsx';
// // import KnowledgeItemDetail from './KnowledgeCenter/KnowledgeItemDetail.jsx';
// // import MemberShipPlan from './components/MemberShipPlan.jsx';
// // import SectorsPage from './components/Sectors/SectorsPage.jsx';
// // import AFCSR from './components/AFCSR.jsx';
// // import SectorDs2 from './components/Sectors/SectorDs2.jsx';
// // import EventPage from './components/EventPage.jsx';
// // import AFCSRPage from './components/AFCSRPage.jsx';
// // import MainInternational from './InternationalPage/MainInternational.jsx';

// // function App() {
// //   return (
// //     <div className="App">
// //       <HashRouter>
// //         {/* Navbar visible on ALL pages */}
// //         <Navbar />

// //         {/* Scroll to top on every route change */}
// //         <ScrollToTop />

// //         <Routes>
// //           <Route path="/" element={<Home />} />
// //           <Route path="/knowledge-report" element={<ReportSection />} />
// //           <Route path="/about-us" element={<AboutUs />} />
// //           <Route path="/about/leadership" element={<LeaderShip />} />
// //           <Route path="/about/our-team" element={<TeamMember />} />
// //           <Route path="/about/past-president" element={<PastPresedent />} />
// //           <Route path="/membership" element={<Membership />} />
// //           <Route path="/overview" element={<MemberShipOverview />} />
// //           <Route path="/membership-types" element={<MemberShipPlan />} />
// //           <Route path="/newsroom/press-release" element={<PressRelease />} />
// //             <Route path="/newsroom/press-coverage" element={<PressCoverage />} />
// //             <Route path="/global-research" element={<GlobalResearch />} />

// //              <Route path="/global-research/economic-growth" element={<ResearchRepositoryPage categoryKey="egd" />} />
// //           <Route path="/global-research/eodb" element={<ResearchRepositoryPage categoryKey="eodb" />} />
// //           <Route path="/global-research/tips" element={<ResearchRepositoryPage categoryKey="tips" />} />
// //           <Route path="/global-research/publications" element={<ResearchRepositoryPage categoryKey="publications" />} />
// //            {/* Knowledge Center */}

// //           <Route path="/overview-knowledge-center" element={<HomeKnowledge />} />
// //           <Route path="/knowledge/reports" element={<AssochamReports />} />
// // <Route path="/knowledge/reports/:id" element={<KnowledgeItemDetail dataKey="reports" />} />

// // <Route path="/knowledge/assocham-voice" element={<AssochamVoice />} />
// // <Route path="/knowledge/assocham-voice/:id" element={<KnowledgeItemDetail dataKey="voices" />} />

// // <Route path="/knowledge/bulletins" element={<AssochamBulletins />} />
// // <Route path="/knowledge/bulletins/:id" element={<KnowledgeItemDetail dataKey="bulletins" />} />
       

// //           <Route path="/knowledge/bulletins" element={<AssochamBulletins />} />
// //           <Route path="/newsroom/image-library" element={<ImageLibrary />} />
// //           <Route path="/agriculture-food-processing" element={<SectorsPage />} />
// //           <Route path="/food-processing-value-addition" element={<SectorDs2 />} />
// //           <Route path="/afcsr" element={<AFCSRPage />} />
// //           <Route path="/events" element={<EventPage />} />
// //           <Route path="/international" element={<MainInternational />} />
          
          

          
// //         </Routes>

// //         {/* Footer visible on ALL pages */}
// //         <MainFooter />
// //       </HashRouter>
// //     </div>
// //   );
// // }

// // export default App;






// // new new code 




// import './App.css';
// import { HashRouter, Routes, Route, Navigate } from "react-router-dom";

// import Navbar from "./components/Navbar";
// import ScrollToTop from "./components/ScrollToTop";
// import MapLocation from "./components/MapLocation";

// // Page Components
// import Home from "./pages/Home.jsx";
// import ReportSection from "./components/Reportsection";
// import MainFooter from './components/MainFooter.jsx';
// import AboutUs from './components/AboutUs.jsx';
// import LeaderShip from './AboutUs/LeaderShip.jsx';
// import TeamMember from './AboutUs/TeamMember.jsx';
// import PastPresedent from './AboutUs/PastPresident.jsx';
// import Membership from './components/MemberShip.jsx';
// import PressRelease from './News/PressRelease.jsx';
// import PressCoverage from './News/PressCoverage.jsx';
// import MemberShipOverview from './components/MemberShipOverview.jsx';
// import GlobalResearch from './GlobalResearch/GlobalResearch.jsx';
// import ResearchRepositoryPage from './GlobalResearch/ResearchRepositoryPage.jsx';
// import HomeKnowledge from './KnowledgeCenter/HomeKnowledge.jsx';
// import AssochamReports from './KnowledgeCenter/AssochamReport.jsx';
// import AssochamVoice from './KnowledgeCenter/AssochamVoice.jsx';
// import AssochamBulletins from './KnowledgeCenter/AssochamBulletins.jsx';
// import ImageLibrary from './News/ImageLibrary.jsx';
// import KnowledgeItemDetail from './KnowledgeCenter/KnowledgeItemDetail.jsx';
// import MemberShipPlan from './components/MemberShipPlan.jsx';
// import AFCSRPage from './components/AFCSRPage.jsx';
// import EventPage from './components/EventPage.jsx';
// import MainInternational from './InternationalPage/MainInternational.jsx';


// import SectorPage from './components/Sectors/SectorsPage.jsx';
// import StatePage from './States/StatePage.jsx';
// import KnowledgeReportDetail from './KnowledgeCenter/KnowledgeReportDetail.jsx';
// import EventDetailPage from './components/EventDetailPage.jsx';
// import PressReleaseDetail from './News/PressReleaseDetail.jsx';
// import GlobalPublications from './GlobalResearch/GobalPublications.jsx';
// import PrivacyPolicy from './components/PrivacyPolicy.jsx';
// import Career from './components/Career.jsx';
// import FinancePage from './AboutUs/FinancePage .jsx';

// function App() {
//   return (
//     <div className="App">
//       <HashRouter>
//         {/* Navbar visible on ALL pages */}
//         <Navbar />

//         {/* Scroll to top on every route change */}
//         <ScrollToTop />

//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/knowledge-report" element={<ReportSection />} />
//           <Route path="/about-us" element={<AboutUs />} />
//           <Route path="/about/leadership" element={<LeaderShip />} />
//           <Route path="/about/our-team" element={<TeamMember />} />
//           <Route path="/about/past-president" element={<PastPresedent />} />
//           <Route path="/membership" element={<Membership />} />
//           <Route path="/overview" element={<MemberShipOverview />} />
//           <Route path="/membership-plans" element={<MemberShipPlan />} />
//           <Route path="/newsroom/press-release" element={<PressRelease />} />
//           <Route path="/press-release/:slug" element={<PressReleaseDetail />} />
//           <Route path="/newsroom/press-coverage" element={<PressCoverage />} />
//           <Route path="/global-research" element={<GlobalResearch />} />

//           <Route path="/global-research/economic-growth" element={<ResearchRepositoryPage categoryKey="egd" />} />
//           <Route path="/global-research/eodb" element={<ResearchRepositoryPage categoryKey="eodb" />} />
//           <Route path="/global-research/tips" element={<ResearchRepositoryPage categoryKey="tips" />} />
//           {/* <Route path="/global-research/publications" element={<GlobalPublications />} /> */}
//           <Route path="/global-research/publications" element={<ResearchRepositoryPage categoryKey="publication" />} />

//           {/* Knowledge Center */}
//           <Route path="/overview-knowledge-center" element={<HomeKnowledge />} />


//           <Route path="/knowledge/reports" element={<AssochamReports />} />
//           {/* <Route path="/knowledge/reports/:id" element={<KnowledgeItemDetail dataKey="reports" />} /> */}
//           <Route path="/knowledge/reports/:slug" element={<KnowledgeReportDetail />} />
//           <Route path="/annual-return" element={<FinancePage />} />
          


//           <Route path="/knowledge/assocham-voice" element={<AssochamVoice />} />
//           {/* <Route path="/knowledge/assocham-voice/:id" element={<KnowledgeItemDetail dataKey="voices" />} /> */}


//           <Route path="/knowledge/bulletins" element={<AssochamBulletins />} />
//           {/* <Route path="/knowledge/bulletins/:id" element={<KnowledgeItemDetail dataKey="bulletins" />} /> */}
//           {/* NOTE: duplicate "/knowledge/bulletins" route hata diya tha jo do baar likha tha */}

//           <Route path="/newsroom/image-library" element={<ImageLibrary />} />

//           {/* ================== SECTORS (60 councils, 1 route) ================== */}
//           <Route path="/sectors/:councilSlug" element={<SectorPage />} />

//        {/*
//           <Route
//             path="/agriculture-food-processing"
//             element={<Navigate to="/sectors/agri-industries-farming-practices" replace />}
//           />

//           <Route
//             path="/food-processing-value-addition"
//             element={<Navigate to="/sectors/food-processing-value-addition" replace />}
//           />
//           */}

//           {/* ===================================================================== */}

//           <Route path="/afcsr" element={<AFCSRPage />} />
//           <Route path="/events" element={<EventPage />} />
//           <Route path="/event-details/:slug" element={<EventDetailPage />} />
//           <Route path="/international" element={<MainInternational />} />
//            <Route path="/:stateSlug" element={<StatePage />} />
//            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//            <Route path="/career" element={<Career />} />


        
//         </Routes>

//         {/* Footer visible on ALL pages */}
//         <MainFooter />
//       </HashRouter>
//     </div>
//   );
// }

// export default App;





// new new code 



import './App.css';
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import ScrollButtons from "./components/ScrollButtons.jsx";
import MapLocation from "./components/MapLocation";

// Page Components
import Home from "./pages/Home.jsx";
import ReportSection from "./components/Reportsection";
import MainFooter from './components/MainFooter.jsx';
import AboutUs from './components/AboutUs.jsx';
import LeaderShip from './AboutUs/LeaderShip.jsx';
import TeamMember from './AboutUs/TeamMember.jsx';
import PastPresedent from './AboutUs/PastPresident.jsx';
import Membership from './components/MemberShip.jsx';
import PressRelease from './News/PressRelease.jsx';
import PressCoverage from './News/PressCoverage.jsx';
import MemberShipOverview from './components/MemberShipOverview.jsx';
import GlobalResearch from './GlobalResearch/GlobalResearch.jsx';
import ResearchRepositoryPage from './GlobalResearch/ResearchRepositoryPage.jsx';
import HomeKnowledge from './KnowledgeCenter/HomeKnowledge.jsx';
import AssochamReports from './KnowledgeCenter/AssochamReport.jsx';
import AssochamVoice from './KnowledgeCenter/AssochamVoice.jsx';
import AssochamBulletins from './KnowledgeCenter/AssochamBulletins.jsx';
import ImageLibrary from './News/ImageLibrary.jsx';
import KnowledgeItemDetail from './KnowledgeCenter/KnowledgeItemDetail.jsx';
import MemberShipPlan from './components/MemberShipPlan.jsx';
import AFCSRPage from './components/AFCSRPage.jsx';
import EventPage from './components/EventPage.jsx';
import MainInternational from './InternationalPage/MainInternational.jsx';


import SectorPage from './components/Sectors/SectorsPage.jsx';
import StatePage from './States/StatePage.jsx';
import KnowledgeReportDetail from './KnowledgeCenter/KnowledgeReportDetail.jsx';
import EventDetailPage from './components/EventDetailPage.jsx';
import PressReleaseDetail from './News/PressReleaseDetail.jsx';
import GlobalPublications from './GlobalResearch/GobalPublications.jsx';
import PrivacyPolicy from './components/PrivacyPolicy.jsx';
import Career from './components/Career.jsx';
import FinancePage from './AboutUs/FinancePage .jsx';
import StickyHubButton from './components/StickyHubButton.jsx';

function App() {
  return (
    <div className="App">
      <HashRouter>
        {/* Navbar visible on ALL pages */}
        <Navbar />

        {/* Scroll to top on every route change */}
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/knowledge-report" element={<ReportSection />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/about/leadership" element={<LeaderShip />} />
          <Route path="/about/our-team" element={<TeamMember />} />
          <Route path="/about/past-president" element={<PastPresedent />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/overview" element={<MemberShipOverview />} />
          <Route path="/membership-plans" element={<MemberShipPlan />} />
          <Route path="/newsroom/press-release" element={<PressRelease />} />
          <Route path="/press-release/:slug" element={<PressReleaseDetail />} />
          <Route path="/newsroom/press-coverage" element={<PressCoverage />} />
          <Route path="/global-research" element={<GlobalResearch />} />

          <Route path="/global-research/economic-growth" element={<ResearchRepositoryPage categoryKey="egd" />} />
          <Route path="/global-research/eodb" element={<ResearchRepositoryPage categoryKey="eodb" />} />
          <Route path="/global-research/tips" element={<ResearchRepositoryPage categoryKey="tips" />} />
          {/* <Route path="/global-research/publications" element={<GlobalPublications />} /> */}
          <Route path="/global-research/publications" element={<ResearchRepositoryPage categoryKey="publication" />} />

          {/* Knowledge Center */}
          <Route path="/overview-knowledge-center" element={<HomeKnowledge />} />


          <Route path="/knowledge/reports" element={<AssochamReports />} />
          {/* <Route path="/knowledge/reports/:id" element={<KnowledgeItemDetail dataKey="reports" />} /> */}
          <Route path="/knowledge/reports/:slug" element={<KnowledgeReportDetail />} />
          <Route path="/annual-return" element={<FinancePage />} />



          <Route path="/knowledge/assocham-voice" element={<AssochamVoice />} />
          {/* <Route path="/knowledge/assocham-voice/:id" element={<KnowledgeItemDetail dataKey="voices" />} /> */}


          <Route path="/knowledge/bulletins" element={<AssochamBulletins />} />
          {/* <Route path="/knowledge/bulletins/:id" element={<KnowledgeItemDetail dataKey="bulletins" />} /> */}
          {/* NOTE: duplicate "/knowledge/bulletins" route removed (it was written twice) */}

          <Route path="/newsroom/image-library" element={<ImageLibrary />} />

          {/* ================== SECTORS (60 councils, 1 route) ================== */}
          <Route path="/sectors/:councilSlug" element={<SectorPage />} />

          {/*
          <Route
            path="/agriculture-food-processing"
            element={<Navigate to="/sectors/agri-industries-farming-practices" replace />}
          />

          <Route
            path="/food-processing-value-addition"
            element={<Navigate to="/sectors/food-processing-value-addition" replace />}
          />
          */}

          {/* ===================================================================== */}

          <Route path="/afcsr" element={<AFCSRPage />} />
          <Route path="/events" element={<EventPage />} />
          <Route path="/event-details/:slug" element={<EventDetailPage />} />
          <Route path="/international" element={<MainInternational />} />
          <Route path="/:stateSlug" element={<StatePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/career" element={<Career />} />
        </Routes>

        {/* Footer visible on ALL pages */}
        <MainFooter />

        {/* Floating scroll buttons (top + bottom) visible on ALL pages */}
        <ScrollButtons />

         <StickyHubButton />
      </HashRouter>
    </div>
  );
}

export default App;